module.exports = __webpack_public_path__ + "static/media/icon-statement-full@2x.5a433199.png";